import SEO from '@/components/SEO';
import { UnifiedProfessionalDirectory } from '@/components/UnifiedProfessionalDirectory';

export default function SeniorCareProfessionalsDirectory() {
  return (
    <>
      <SEO
        title="Senior Care Professionals Directory"
        description="Find senior care professionals in the SeniorThrive network. Browse specialties, service areas, and contact details."
        keywords="senior care professional, geriatric care, elder care, aging specialist, care manager directory"
        canonical="https://seniorthrive.com/senior-care-professionals/directory"
      />
      
      <UnifiedProfessionalDirectory 
        professionType="Senior Care Professional"
        title="Senior Care Professionals Directory"
        description="Browse senior care professionals in the SeniorThrive network."
      />
    </>
  );
}